<template>
  <div class="add-recipe container">
    <div class="card white">
      <div class="card-content">
        <h2 class="center-align blue-grey-text text-darken-4">Add new recipe</h2>
        <form @submit.prevent="AddRecipe">
          <div class="field title">
            <label for="title">Recipe name:</label>
            <input type="text" name="title" v-model="title">
          </div>
          <div v-for="(ing, index) in ingredients" :key="index" class="field">
            <label for="ingredient">Ingredient:</label>
            <input type="text" name="ingredient" v-model="ingredients[index]">
            <i class="material-icons delete red-text text-lighten-3" @click="DeleteIngredient(ing)">delete</i>
          </div>
          <div class="field add-ingredient">
            <label for="add-ingredient">Ingredient name:</label>
            <input
              type="text"
              name="add-ingredient"
              @keydown.tab.prevent="AddIngredient"
              v-model="another"
            >
            <p class="center-align note-text grey-text">Hit tab key to add ingredient</p>
            <div class="field center-align">
              <p v-if="feedback" class="red-text">{{ feedback }}</p>
              <button class="btn light-green darken-4">Add recipe</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import db from "@/firebase/init";
import slugify from "slugify";

export default {
  name: "AddRecipe",
  data() {
    return {
      title: null,
      another: null,
      ingredients: [],
      slug: null,
      feedback: null
    };
  },
  methods: {
    AddRecipe() {
      if (this.title) {
        this.feedback = null;
        // Create slug with slugify using recipe title
        this.slug = slugify(this.title, {
          replacement: "-",
          remove: /[$*_+~.()'"!\-:@]/g,
          lower: true
        });
        db.collection("recipes")
          .add({
            title: this.title,
            ingredients: this.ingredients,
            slug: this.slug
          })
          .then(() => {
            this.$router.push({ name: "Index" });
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.feedback = "You must enter a title for your recipe";
      }
    },
    AddIngredient() {
      if (this.another) {
        this.ingredients.push(this.another);
        this.another = null;
        this.feedback = null;
      } else {
        this.feedback = "You must enter a value to add an ingredient";
      }
    },
    DeleteIngredient(ing) {
      this.ingredients = this.ingredients.filter(
        ingredient => ingredient != ing
      );
    }
  }
};
</script>

<style lang=''>
.add-recipe {
  margin-top: 60px;
  padding: 20px;
  max-width: 500px;
}
.add-recipe h2 {
  font-size: 2em;
  margin: 20px auto;
}
.add-recipe .field {
  margin: 20px auto;
  position: relative;
}
.add-recipe .note-text {
  font-size: 0.75em;
}
.add-recipe .delete {
  position: absolute;
  right: 0;
  bottom: 16px;
  color: #aaa;
  font-size: 1.4em;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/AddRecipe.vue